module.exports = __webpack_public_path__ + "img/dianzishusaoma.aa8a56bb.png";